<p class="font-bold line-height-2" i18n>
  It is possible for the home network to identify alternative network IDs as the Home PLMN. These network IDs are stored in the Equivalent
  Home PLMN list. The entries in the EHPLMN list are used in the network selection procedure. It's also allowed to enter the Home PLMN
  derived from the IMSI.
</p>
<p class="font-bold line-height-2" id="homePLMN#toggle" i18n>Do you want to use the Equivalent Home PLMN list?</p>
<div role="radiogroup" aria-labelledby="homePLMN#toggle" class="ml-6 flex gap-3">
  <rs-labeled-field label="Yes" i18n-label labelClass="label-clickable" [reverse]="true">
    <ng-template #fieldInput let-id>
      <p-radioButton
        (onClick)="updateEquivalentHomePLMN()"
        name="useEquivalentHomePLMN"
        [inputId]="id"
        value="1"
        [(ngModel)]="profileValues.useEquivalentHomePLMN"
      ></p-radioButton>
    </ng-template>
  </rs-labeled-field>
  <rs-labeled-field label="No" i18n-label labelClass="label-clickable" [reverse]="true">
    <ng-template #fieldInput let-id>
      <p-radioButton
        (onClick)="updateEquivalentHomePLMN()"
        name="useEquivalentHomePLMN"
        [inputId]="id"
        value="0"
        class="ml-4"
        [(ngModel)]="profileValues.useEquivalentHomePLMN"
      ></p-radioButton>
    </ng-template>
  </rs-labeled-field>
</div>
<p *ngIf="+profileValues.useEquivalentHomePLMN === 1" class="font-bold" i18n>Please enter a PLMN or PLMNs in the order of priority.</p>
<div *ngIf="+profileValues.useEquivalentHomePLMN === 1" class="ml-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <div style="width: 550px">
    <p-table showGridlines="true" stripedRows="true" [value]="profileValues.equivalentHomePLMN">
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 7rem" />
          <col />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th i18n>Record #</th>
          <th>
            <div i18n>Mobile Contry Code</div>
            <div class="font-medium" i18n>(3-digit number)</div>
          </th>
          <th>
            <div i18n>Mobile Network Code</div>
            <div class="font-medium" i18n>(2 to 3-digit number)</div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-record let-rowIndex="rowIndex">
        <tr>
          <td class="text-center">{{ rowIndex + 1 }}</td>
          <td>
            <input
              pInputText
              rsNumbersOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="3"
              [(ngModel)]="record.mobileCountryCode"
              (ngModelChange)="record.mobileCountryCode = convertToNull($event)"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <input
              pInputText
              rsNumbersOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="3"
              [(ngModel)]="record.mobileNetworkCode"
              (ngModelChange)="record.mobileNetworkCode = convertToNull($event)"
              (input)="handleFormEvents()"
            />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" i18n>No records defined.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
